<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb"></sm-page-header>
    <div class="content">
        <div class="shadow-sm flex flex-col gap-5 p-2 border rounded-md" *ngIf="data">
            <h3 class="text-lg font-semibold mb-4 flex items-center gap-2">
                <i class="pi pi-calendar"></i>
                {{ "meeting.history.table.details" | translate }}
            </h3>
            <div class="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm mb-4">
                <div><span class="font-medium"> {{ "meeting.history.table.meetingDate" | translate }} : </span> {{
                    data.reunionDate | date: 'dd/MM/yyyy HH:mm' }}</div>
                <div><span class="font-medium"> {{ "meeting.history.table.meetingPlace" | translate }} : </span> {{
                    data.emplacement }}</div>
                <div class="inline-flex gap-2"><span class="font-medium"> {{ "meeting.history.table.meetingObject" |
                        translate }} : </span> <span [innerHTML]="data.object"></span></div>
                <div class="capitalize"><span class="font-medium">{{ "meeting.history.table.createdBy" | translate
                        }}</span> {{ data.createdBy }}</div>
                <div><span class="font-medium"> {{ "meeting.history.table.createdAt" | translate }} : </span> {{
                    data.metadata.createdAt | date: 'dd/MM/yyyy HH:mm' }}</div>
                <div><span class="font-medium">{{ "meeting.history.table.updatedAt" | translate }} : </span> {{
                    data.metadata.updatedAt | date: 'dd/MM/yyyy HH:mm' }}
                </div>
            </div>
            <h4 class="text-md font-semibold mb-4 flex items-center gap-2">
                <i class="pi pi-users"></i>
                {{ "meeting.history.table.participants" | translate }}
            </h4>
            <sm-presence-data-table [disabled]="true" />
            <sm-preview-pdf [src]="verbalProcessFileSrc" />
            <div *ngIf="data.extraits && data.extraits.length > 0">
                <h4 class="text-md font-semibold mb-4 flex items-center gap-2">{{ 'meeting.snippets.title' | translate }} : </h4>
                <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data.extraits" [loading]="loading"></sm-data-table-builder>
            </div>
        </div>
        <sm-spinner [loading]="loading"></sm-spinner>

    </div>
</div>